export default __webpack_public_path__ + "static/media/ic-logout.81151058.svg";